module.exports = __webpack_public_path__ + "fonts/open-sauce-sans-latin-700-normal.8317b1f.woff";